
import { defineComponent } from 'vue'
import { PrimaryButton } from '@/components/buttons'
import { LeftArrow } from '@/components/icons'
import { WorkReportCard } from '@/components'
import { IClockingInsStoreState } from '@/interfaces'
import { createNamespacedHelpers } from 'vuex'
import { ClockingInScope } from '@/enums'
const { mapState } = createNamespacedHelpers('workReports')

export default defineComponent({
  name: 'WorkReports',

  components: { LeftArrow, PrimaryButton, WorkReportCard },

  data () {
    return {
      searchQuery: '',
      isShowingUserAssignment: false,
      ClockingInScope
    }
  },

  props: {
    scope: {
      type: Number as () => ClockingInScope,
      required: true
    }
  },

  /**  Bind Vuexfire on client-side: */
  async beforeMount () {
    console.log('ClockingIns - beforeMount', { params: this.$route.params })
    this.paginate(true)
  },

  computed: {
    ...mapState<IClockingInsStoreState>({
      workReports: (state: any) => state.workReports
    }),
    id: function (): string | undefined {
      switch (this.scope) {
        case ClockingInScope.workingSite: return this.$route.params.workingSiteId as string
        case ClockingInScope.user: return this.$route.params.userId as string
        default: return undefined
      }
    },
    facetFilters: function (): string[] {
      switch (this.scope) {
        case ClockingInScope.workingSite: return [`workingSiteId:${this.id}`]
        case ClockingInScope.user: return [`userId:${this.id}`]
        default: return []
      }
    }
  },

  methods: {
    goBack () {
      return this.$router.go(-1)
    },
    paginate: async function (forceReload = false): Promise<void> {
      console.log('search', { query: this.searchQuery })

      await this.$store.dispatch('workReports/paginateWorkReports', {
        userId: this.$route.params.userId,
        workingSiteId: this.$route.params.workingSiteId,
        forceReload,
        limit: 15
      })
    }
  },

  watch: {
    workReportsSearchQuery: function (value) {
      console.log('received a search query', { value })
      this.searchQuery = value
    }
  }
})
